import React, { useEffect, useState } from 'react';
import { Container, Card, Form, Button, Row, Col } from 'react-bootstrap';
import { FaUpload, FaFilePdf, FaTrash, FaInfoCircle, FaEye, FaDownload } from 'react-icons/fa';
import { useFormik, FormikProvider, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { downloadBase64Pdf, ImagePdfBucket } from '../CommonUtils/ImagesBase64';
import { viewImage } from '../CommonUtils/viewImage';
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import { config } from '../CommonUtils/CommonURLS';
import { failureAlert, successAlert2 } from '../CommonUtils/SweetAlerts';
import CommonCardHeader from '../CommonUtils/CommonCardHeader';
export default function StudentDocumentUpload({ refreshStatus, paymentFlag }) {
    const [uploading, setUploading] = useState(false);
    const [filePreviews, setFilePreviews] = useState({
        undertaking: { file: null, name: '', size: '' },
        supportingDocument: { file: null, name: '', size: '' },
        paymentReceipt: { file: null, name: '', size: '' }
    });
    const formik = useFormik({
        initialValues: {
            undertaking: '',
            supportingDocument: '',
            // paymentReceipt: '',
            agreeToTerms: false
        },

        validationSchema: Yup.object({
            undertaking: Yup.string()
                .required('Student Undertaking form is required'),
            supportingDocument: Yup.string()
                .required('Supporting Document for Transfer is required'),
            // paymentReceipt: Yup.string()
            //     .required('Payment Receipt is required'),
            agreeToTerms: Yup.boolean()
                .oneOf([true], 'You must read and agree to all conditions before submitting')
                .required('You must agree to the conditions')
        }),

        onSubmit: async (values) => {
            if (!validateFiles()) {
                return;
            }
            setUploading(true);
            submitUploads(values, filePreviews);
            // setUploading(false);

            // const formData = new FormData();
            // formData.append('undertaking', filePreviews.undertaking.file);
            // formData.append('supportingDocument', filePreviews.supportingDocument.file);
            // formData.append('paymentReceipt', filePreviews.paymentReceipt.file);

            // try {
            //     // Your API call here
            //     console.log('Submitting:', formData);
            //     console.log('Form Values:', values);
            //     // Reset form
            //     // formik.resetForm();
            //     setFilePreviews({
            //         undertaking: { file: null, name: '', size: '' },
            //         supportingDocument: { file: null, name: '', size: '' },
            //         paymentReceipt: { file: null, name: '', size: '' }
            //     });

            // } catch (error) {
            //     alert('Upload failed. Please try again.');
            // } finally {
            //     setUploading(false);
            // }
        }
    });
    const validateFiles = () => {
        if (!filePreviews.undertaking.file && !formik.values.undertaking) {
            formik.setFieldError('undertaking', 'Student Undertaking form is required');
            return false;
        }
        if (!filePreviews.supportingDocument.file && !formik.values.supportingDocument) {
            formik.setFieldError('supportingDocument', 'Supporting Document for Transfer is required');
            return false;
        }
        // if (!filePreviews.paymentReceipt.file && !formik.values.paymentReceipt) {
        //     formik.setFieldError('paymentReceipt', 'Payment Receipt is required');
        //     return false;
        // }
        return true;
    };
    function submitUploads(values, filePreviews) {
        const params = {
            agreeToTerms: values.agreeToTerms,
            undertaking: values.undertaking,
            supportingDocument: values.supportingDocument,
            paymentReceipt: values.paymentReceipt,
            undertakingFileName: filePreviews.undertaking?.name || "",
            supportingDocumentFileName: filePreviews.supportingDocument?.name || "",
            paymentReceiptFileName: filePreviews.paymentReceipt?.name || "",
            undertakingFileSize: filePreviews.undertaking?.size || "",
            supportingDocumentFileSize: filePreviews.supportingDocument?.size || "",
            paymentReceiptFileSize: filePreviews.paymentReceipt?.size || ""
        };
        let url = config.url.STU_URL + "saveStudentUploads";
        CommonAxiosPost(url, params).then((res) => {
            if (res !== null) {
                if (res.data.scode === "01") {
                    successAlert2(res.data.sdesc);
                    fetchStudentDocuments();
                    refreshStatus();

                    // formik.resetForm();
                    // setFilePreviews({
                    //     undertaking: { file: null, name: '', size: '' },
                    //     supportingDocument: { file: null, name: '', size: '' },
                    //     paymentReceipt: { file: null, name: '', size: '' }
                    // });
                } else {
                    failureAlert(res.data.sdesc);
                }
            }
        }).catch((error) => {
            console.error("Error:", error);
            failureAlert("Something went wrong!");
        });
    }
    useEffect(() => {
        fetchStudentDocuments();
    }, []);
    const fetchStudentDocuments = async () => {
        try {
            let url = config.url.STU_URL + "getStudentUploads";
            const response = await CommonAxiosGet(url);
            // console.log("response", response.data.data);
            if (response !== null) {
                // console.log("Document data:", response.data.data);
                const data = response.data.data || [];
                // console.log("Document data after null check:", data);

                if (data.length > 0) {
                    const documentData = data[0];

                    formik.setFieldValue(
                        'undertaking',
                        documentData?.undertaking_doc || ''
                    );

                    formik.setFieldValue(
                        'supportingDocument',
                        documentData?.supporting_document || ''
                    );

                    formik.setFieldValue(
                        'paymentReceipt',
                        documentData?.payment_receipt || ''
                    );

                    formik.setFieldValue(
                        'agreeToTerms',
                        documentData?.agreetoterms || false
                    );

                    // CHANGE HERE: Set file as null (not the path string)
                    setFilePreviews({
                        undertaking: {
                            file: null,  // ← Change this
                            name: documentData?.undertaking_doc
                                ? documentData.undertaking_doc.split('/').pop()
                                : '',
                            size: ''
                        },
                        supportingDocument: {
                            file: null,  // ← Change this
                            name: documentData?.supporting_document
                                ? documentData.supporting_document.split('/').pop()
                                : '',
                            size: ''
                        },
                        paymentReceipt: {
                            file: null,  // ← Change this
                            name: documentData?.payment_receipt
                                ? documentData.payment_receipt.split('/').pop()
                                : '',
                            size: ''
                        }
                    });
                }
            }
        } catch (error) {
            console.error("Error fetching documents:", error);
        }
    };
    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type !== 'application/pdf') {
                alert('Only PDF files are allowed');
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                alert('File size should be less than 5MB');
                return;
            }
            setFilePreviews({
                ...filePreviews,
                [type]: {
                    file: file,
                    name: file.name,
                    size: (file.size / 1024).toFixed(2) + ' KB'
                }
            });
            formik.setFieldValue(type, file.name);
            formik.setFieldError(type, undefined);
        }
    };
    const removeFile = (type) => {
        setFilePreviews({
            ...filePreviews,
            [type]: { file: null, name: '', size: '' }
        });
        formik.setFieldValue(type, '');
        formik.setFieldError(type, 'Required');
        const inputElement = document.getElementById(type);
        if (inputElement) {
            inputElement.value = '';
        }
    };
    const renderUploadField = (label, fieldName, example) => {
        return (
            <Form.Group className="mb-4">
                <Form.Label className="fw-bold">
                    {label} <span className="text-danger">*</span>
                    {example && (
                        <small className="text-muted ms-2">
                            (Example: {example})
                        </small>
                    )}
                </Form.Label>
                <div
                    className={`border rounded p-3 bg-light ${formik.errors[fieldName] ? "border-danger" : ""
                        }`}
                >
                    <div className="d-flex align-items-center gap-2">
                        <input
                            type="file"
                            className="form-control"
                            accept=".pdf"
                            id={fieldName}
                            name={fieldName}
                            disabled={paymentFlag}
                            onChange={(e) => {
                                const selectedFile = e.target.files[0];
                                if (!selectedFile) {
                                    return;
                                }

                                let filename = fieldName;
                                let path = "/Uploads/StudentTransfer/";

                                ImagePdfBucket(e, formik, path, fieldName, filename, "pdf").then((uploadedPath) => {
                                    setFilePreviews({
                                        ...filePreviews, [fieldName]: {
                                            file: uploadedPath, name: selectedFile?.name, size: (
                                                selectedFile?.size / 1024
                                            ).toFixed(2) + " KB"
                                        }
                                    });

                                    formik.setFieldValue(
                                        fieldName,
                                        uploadedPath
                                    );

                                    formik.setFieldError(
                                        fieldName,
                                        undefined
                                    );
                                });
                            }}
                        />
                        {(formik.values[fieldName] || filePreviews[fieldName]?.file) && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() =>
                                    viewImage(formik.values[fieldName])
                                }
                            >
                                <FaEye />
                            </button>
                        )}
                        {(formik.values[fieldName] || filePreviews[fieldName]?.file) && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => removeFile(fieldName)}
                                disabled={paymentFlag}
                            >
                                <FaTrash />
                            </button>
                        )}
                    </div>
                    {/* {filePreviews[fieldName]?.name && (
                        <div className="mt-2">
                            <FaFilePdf
                                className="text-danger me-2"
                            />
                            <span className="fw-bold">
                                {filePreviews[fieldName]?.name}
                            </span>
                            <small className="text-muted ms-2">
                                ({filePreviews[fieldName]?.size})
                            </small>
                        </div>
                    )} */}
                </div>
                <ErrorMessage
                    name={fieldName}
                    component="div"
                    className="text-danger small mt-1"
                />
            </Form.Group>
        );
    };
    function getPdfUrl() {
        CommonAxiosPost(`${config.url.STU_URL}undertakingletter`)
            .then((res) => {
                const base64Pdf = res?.data?.pdf;
                if (base64Pdf) {
                    const fileName = `Undertaking_Letter_.pdf`;

                    downloadBase64Pdf(base64Pdf, fileName);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    }

    const downloadMedicalCertificate = () => {
        const fileName = 'ABCD Medical Certificate proforma_20250613_125321.pdf';
        const encodedFileName = encodeURIComponent(fileName);
        const fileUrl = `${window.location.origin}/${encodedFileName}`;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const actionButtonStyle = {
        padding: '8px 14px',
        fontWeight: 'bold',
        borderRadius: '8px'
    };
    const linkStyle = (color) => ({
        textDecoration: "none",
        backgroundColor: color,
        color: "#111111",
        padding: "8px 12px",
        borderRadius: "6px",
        fontWeight: "500",
        display: "inline-block",
        fontSize: "16px",
        whiteSpace: "nowrap"
    })
    return (
        <FormikProvider value={formik}>
            <Container fluid className="p-0 m-0">
                <Row className="justify-content-center m-0 p-0">
                    <Col md={8} className="p-0">
                        {/* <div className="d-flex flex-wrap justify-content-end gap-2 mb-2">
                            <Button
                                type="button"
                                variant="primary"
                                onClick={getPdfUrl}
                                style={{
                                    ...actionButtonStyle,
                                    backgroundColor: '#28a745',
                                    borderColor: '#28a745'
                                }}
                                className="d-flex align-items-center justify-content-center"
                            >
                                <FaDownload className="me-2" /> Download Undertaking Letter
                            </Button>
                            <Button
                                type="button"
                                variant="primary"
                                onClick={downloadMedicalCertificate}
                                style={{
                                    ...actionButtonStyle,
                                    backgroundColor: '#17a2b8',
                                    borderColor: '#17a2b8'
                                }}
                                className="d-flex align-items-center justify-content-center"
                            >
                                <FaDownload className="me-2" /> Download Medical Certificate
                            </Button>
                        </div> */}
                        <div
                            style={{
                                border: "1px solid #e5e7eb",
                                borderRadius: "10px",
                                padding: "12px 14px",
                                backgroundColor: "#f9fafb",
                                marginBottom: "12px"
                            }}
                        >
                            <strong style={{ fontSize: "20px", fontFamily: "-apple-system" }}>
                                📌 NOTE: Kindly download the templates, complete the required signature, and upload only the duly signed copies.
                            </strong>

                            <div
                                style={{
                                    display: "flex",
                                    gap: "12px",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    marginTop: "10px"
                                }}
                            >
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        getPdfUrl();
                                    }}
                                    style={linkStyle("#d8eedd")}
                                >
                                    <FaDownload className="me-2" />   Undertaking Letter
                                </a>

                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        downloadMedicalCertificate();
                                    }}
                                    style={linkStyle("#90bdc4")}
                                >
                                    <FaDownload className="me-2" />   Medical Certificate
                                </a>
                            </div>
                        </div>


                        <section className="workflow-section-surface" style={{ marginTop: 0, paddingTop: 0 }}>
                            <CommonCardHeader title="Student Documents Upload" />
                            <div className="workflow-section-body">
                                <Form onSubmit={formik.handleSubmit}>
                                    <p className="mb-2">
                                        <strong>
                                            <span className="text-danger">Note:</span> Click on choose file and upload the necessary documents (i.e., Student Undertaking, Supporting Document for Transfer)
                                        </strong>
                                    </p>
                                    {renderUploadField('Student Undertaking Form', 'undertaking', 'student_undertaking.pdf')}
                                    {renderUploadField('Supporting Document for Transfer', 'supportingDocument', 'medical_certificate.pdf')}
                                    {/* {renderUploadField('Payment Receipt', 'paymentReceipt', 'payment_receipt.pdf')} */}
                                    <div className="mb-4 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                        <ul className="mb-0">
                                            <li className="mb-2">
                                                Students who are admitted under Category B i.e. Management quota or Spot Admission Under Category A in an institution and subsequently transferred to other institution under 1% ceiling or unfixed vacancies of Convenor quota i.e. Category A are not eligible to claim tuition fee reimbursement / Scholarship.
                                            </li>
                                            <li className="mb-2">
                                                Students who are admitted under Convenor Quota (i.e. Category A) & eligible for fee reimbursement, if subsequently transferred to other institutions under the unfilled vacancy of Category B seats shall not be eligible to claim Tuition Fee Reimbursement / scholarship.
                                            </li>
                                            <li className="mb-2">
                                                The difference in the tuition fee to be paid in the institutions now transferred shall be the responsibility of the students/Parents.
                                            </li>
                                            <li className="mb-2">
                                                The transfer processing fee, once paid will not be refunded under any circumstances (even if the transfer not effected/ colleges not issued NOC).
                                            </li>
                                        </ul>
                                        <p className="mb-0 fw-bold text-danger">
                                            ⚠️ Please read all the conditions before submitting.
                                        </p>
                                    </div>
                                    <Form.Group className="mb-4">
                                        <Form.Check
                                            type="checkbox"
                                            id="agreeToTerms"
                                            name="agreeToTerms"
                                            label="I have read and understood all the conditions mentioned above"
                                            checked={formik.values.agreeToTerms}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isInvalid={formik.touched.agreeToTerms && formik.errors.agreeToTerms}
                                        />
                                        <ErrorMessage name="agreeToTerms" component="div" className="text-danger small mt-1" />
                                    </Form.Group>
                                    <div className="text-center">
                                        {paymentFlag ? (
                                            <div style={{ color: "green", fontWeight: "bold" }}>
                                                ✅ Already submitted
                                            </div>
                                        ) : (
                                            <Button type="submit" variant="success" className="px-5" size="lg">
                                                Submit
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </FormikProvider>
    );
}